import { encodeQueryParams } from 'util/url'
import ApiError from 'ApiError'

import 'unfetch/polyfill'
import getBackendURL from 'util/backend-url'

const ApiCall = (path, method, body, customHeaders) => {
  const time = Date.now()
  let headers
  if (customHeaders) {
    headers = customHeaders
  } else {
    headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }

  const cookies = document.cookie.split('; ')
  const token = cookies.find(c => c.startsWith('keep_auth_token'))
  if (token) {
    headers.Authorization = `Token ${token.split('=')[1]}`
  }
  const apiUrl = getBackendURL()
  return fetch(apiUrl + path, {
    headers,
    method,
    mode: 'cors',
    body: body || undefined
  }).then(response =>
    response[response.status === 204 ? 'text' : 'json']()
      .then(json => {
        if (!response.ok) {
          const Error = new ApiError(response, json)

          return Promise.reject(Error)
        }
        if (
          path.indexOf('/api/search/projects') !== -1 ||
          path.indexOf('/api/search/programmes') !== -1 ||
          path.indexOf('/api/search/partners') !== -1 ||
          (path.indexOf('/api/search/heatmap') !== -1 && path.indexOf('partnership') === -1)
        ) {
          return { ...json, time }
        }
        return json
      })
      .catch(error => Promise.reject(error))
  )
}

export function Get(path, params = {}, headers = false) {
  return ApiCall(path + encodeQueryParams(params), 'GET', null, headers)
}

export function Post(path, body, params = {}) {
  return ApiCall(path + encodeQueryParams(params), 'POST', body)
}

export function Put(path, body) {
  return ApiCall(path, 'PUT', body)
}

export function Patch(path, body) {
  return ApiCall(path, 'PATCH', body)
}

export function Delete(path) {
  return ApiCall(path, 'DELETE', null)
}
